import HelperMixin from '../../Shared/HelperMixin.vue';

// SCH-13 — Daily school attendance / absences viewer.
// Backed by GET api/admin/SchoolTrips/Absences (exists). Supports CSV
// export client-side so operators don't need to wait for backend changes.

export default {
    name: 'SchoolAttendanceReport',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // Audit P1 #5 — GetAbsences pins school-admins (40/41) to their own school.
        if (!this.requireUserType([1, 40, 41])) return;
    },

    data() {
        return {
            Items: [],
            SchoolId: null,
            From: '',
            To: '',
        };
    },

    computed: {
        TotalAbsences() { return this.Items.length; },
        UniqueStudents() {
            const set = new Set();
            this.Items.forEach(it => { if (it.studentId || it.studentName) set.add(it.studentId || it.studentName); });
            return set.size;
        },
        UniqueDays() {
            const set = new Set();
            this.Items.forEach(it => { if (it.date || it.absenceDate) set.add(it.date || it.absenceDate); });
            return set.size;
        }
    },

    methods: {
        async Load() {
            this.$blockUI.Start();
            try {
                const from = this.From ? this.ChangeDate(this.From) : '';
                const to = this.To ? this.ChangeDate(this.To) : '';
                const res = await this.$http.GetSchoolAttendance(this.SchoolId, from, to);
                const data = res.data || {};
                this.Items = data.items || data.info || data || [];
            } catch (e) {
                this.Items = [];
            } finally {
                this.$blockUI.Stop();
            }
        },
        ExportCsv() {
            if (!this.Items.length) return;
            const headers = ['#', 'التاريخ', 'الطالب', 'الصف', 'ولي الأمر', 'الرحلة', 'السبب'];
            const rows = this.Items.map((it, idx) => [
                idx + 1,
                it.date || it.absenceDate || '',
                it.studentName || '',
                it.className || it.classRoom || '',
                it.parentName || '',
                it.tripName || it.routeName || '',
                (it.reason || '').replace(/,/g, ';')
            ]);
            const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
            const blob = new Blob([new TextEncoder().encode('﻿' + csv)], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `attendance_${this.SchoolId || 'all'}_${Date.now()}.csv`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }
};
